<template>
  <div id="app">


    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
      :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
    </v-snackbar>

    <v-dialog v-model="faturadialoggoster" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">

            <div class="flex md12">
              <span id="demo2">
              </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="faturadialog" width="500">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Dikkat!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{dialogmesaj}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="mesajiptal()">
            İptal
          </v-btn>
          <v-btn color="primary" flat @click="faturala()">
            Faturala
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Fatura Basma</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="750px">
            <v-card color="grey lighten-2">
              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-select :items="masrafmerkezi" hide-details="" label="Masraf Merkezi" item-text="CodeName"
                        clearable item-value="Code" v-model="faturaList.Filtreler.Masraf" max-height="400"></v-select>
                      <referansmerkezicomp v-model="faturaList.Filtreler.Referans"></referansmerkezicomp>
                      <v-select :items="hesapgurubu" hide-details="" v-model="faturaList.Filtreler.HesapGrubu" label="Hesap Grubu"
                        item-text="Adi" item-value="Kod" max-height="400"></v-select>

                      <v-autocomplete hide-details="" clearable :items="gdsitems" label="GDS" multiple item-text="text"
                        v-model="faturaList.Filtreler.GDSler" item-value="value">
                        <template slot="selection" slot-scope="{ item, index }">
                          <div v-if="index === 0">
                            <span>{{item.text}}</span>
                          </div>
                          <span v-if="index === 1" class="grey--text caption">(+{{
                            faturaList.Filtreler.GDSler.length -
                            1
                            }} diğer)</span>
                        </template>
                      </v-autocomplete>
                      <v-checkbox hide-details="" v-model="faturaList.Filtreler.SifirTutar" label="Sıfır Tutarlı Biletleri Faturalama"></v-checkbox>


                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>

                      <bolumcomp v-model="faturaList.Filtreler.BolumKodu"></bolumcomp>
                      <v-text-field v-model="faturaList.Filtreler.SiparisNo" label="Sipariş No" hide-details=""></v-text-field>

                      <v-autocomplete hide-details="" clearable :items="itemsairlinelist" label="Havayolu Seçimi"
                        multiple item-text="HavaYoluTitle" v-model="faturaList.Filtreler.Havayollari" item-value="HavaYoluKodu">
                        <template slot="selection" slot-scope="{ item, index }">
                          <div v-if="index === 0">
                            <span>{{ item.HavaYoluAdi }}</span>
                          </div>
                          <span v-if="index === 1" class="grey--text caption">(+{{
                            faturaList.Filtreler.Havayollari.length -
                            1
                            }} diğer)</span>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete hide-details="" clearable :items="odemesekli" label="Ödeme Şekli Seçimi" multiple
                        item-text="text" v-model="faturaList.Filtreler.Odemeler" item-value="value">
                        <template slot="selection" slot-scope="{ item, index }">
                          <div v-if="index === 0">
                            <span>{{ item.text }}</span>
                          </div>
                          <span v-if="index === 1" class="grey--text caption">(+{{
                            faturaList.Filtreler.SiparisNo.length -
                            1
                            }} diğer)</span>
                        </template>
                      </v-autocomplete>


                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>

                    <br>
                    <div class="card__text info white--text">
                      <h3> &nbsp; Seçenekler</h3>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>

                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm4 md4>
                    <v-layout justify-space-between column>
                      <v-radio-group v-model="faturaList.Filtreler.TarihTipi" label="Tarih Tipi" column>
                        <v-radio label="Satış Tarihi" :value="'0'"> </v-radio>
                        <v-radio label="Satış-Uçuş Tarihi" :value="'1'"></v-radio>
                        <v-radio label="Satış-Dönüş Tarihi" :value="'2'"></v-radio>
                        <v-radio label="Satış Uçuş-Dönüş Tarihi" :value="'3'"></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-layout justify-space-between column>
                      <v-radio-group v-model="faturaList.Filtreler.CariTip" label="Müşteri tipi" column>
                        <v-radio label="Tümü" :value="'0'"> </v-radio>
                        <v-radio label="Bireysel" :value="'1'"></v-radio>
                        <v-radio label="Kurumsal" :value="'2'"></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm4 md4>
                    <v-layout justify-space-between column>
                      <v-radio-group v-model="faturaList.Filtreler.UcusTip" label="Kıbrıs/Batum Uçuşları" column>
                        <v-radio label="Tümü" :value="'0'"> </v-radio>
                        <v-radio label="ECN-BUS Hariç" :value="'1'"></v-radio>
                        <v-radio label="Sadece ECN-BUS" :value="'2'"></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-flex>



                  <v-flex xs12 sm4 md4>
                    <v-layout justify-space-between column>
                      <v-radio-group label="E-Fatura Durumu" v-model="faturaList.Filtreler.EFaturaKayitli" column>
                        <v-radio label="E-Fatura Kayıtsız Müşteri" :value="false"> </v-radio>
                        <v-radio label="E-Fatura Kayıtlı Müşteri" :value="true"></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-layout justify-space-between column>
                      <v-radio-group v-model="faturaList.Filtreler.HatBilgi" label="Hat Tipi" column>
                        <v-radio label="İç Hat" :value=false> </v-radio>
                        <v-radio label="Dış Hat" :value=true></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="getList()">Kayıtları Getir</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogopsiyon" scrollable="" persistent="" max-width="750px">
            <v-card color="grey lighten-2">
              <v-card-title>Opsiyon Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>

                      <tarihcomp :etiket="'Fatura Tarihi'" v-bind:defaultvalue="'ok'" v-bind:value="faturaList.FaturaTarih"
                        v-model="faturaList.FaturaTarih"></tarihcomp>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout justify-space-between column>
                      <v-select :items="gibSeri1" hide-details="" v-model="faturaList.GibSeri" label="GİB Seri"
                        item-text="Seri" item-value="Seri" max-height="400"></v-select>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <!-- <v-select :items="dizayntipi" hide-details="" v-model="faturaList.FaturaBilgi.FaturaTip" clearable
                      item-text="text" @change="dizayngetir()" item-value="value" label="Dizayn Tipi"></v-select> -->
                    <v-select :items="dizaynsec" @change="xsltsec(faturaList.FaturaBilgi.FaturaID)" v-model="faturaList.FaturaBilgi.FaturaID"
                      hide-details="" clearable item-text="FaturaAciklama" item-value="FaturaId" label="Dizayn Seç"></v-select>
                    <v-select :items="xsltitems" v-model="faturaList.FaturaBilgi.FaturaXSLTID" hide-details=""
                      clearable item-text="XsltAciklama" item-value="FaturaId" label="xslt Dosyası Seç"></v-select>
                    <reportbrosablon ref="reportbrosablon" v-model="faturaList.FaturaBilgi.FaturaPdfID" dizayngrupadi="Fatura"
                      objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                  </v-flex>
                  <v-flex xs12 sm12 md12>

                    <br>
                    <div class="card__text info white--text">
                      <h3> &nbsp; Seçenekler</h3>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <!-- <v-checkbox   label="Unvan ve Adres Bilgilerinde Deşiklik Yap" v-model="faturaList.Opsiyonlar.UnvanAdres"  hide-details=""></v-checkbox> -->
                      <v-layout>
                        <v-checkbox v-model="faturaList.Opsiyonlar.DovizliFatura" label="Dövizli Fatura" hide-details=""></v-checkbox>
                        <v-flex xs12 sm3 md4>
                          <v-autocomplete v-if="dovizlifaturami" hide-details="" @change="kurgetir(faturaList.DovizBilgi.DDovizTipi)"
                            :items="doviztipi" v-model="faturaList.DovizBilgi.DDovizTipi" clearable item-text="DovizUnvan"
                            item-value="DovizKod" label="Döviz Tipi"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm3 md3>
                          <dovizinput v-if="dovizlifaturami" v-model="faturaList.DovizBilgi.DKur" :etiket="'Kur Tutarı'">
                          </dovizinput>
                        </v-flex>
                      </v-layout>
                      <v-checkbox label="Yolcu İsmi Basılmasın" v-model="faturaList.Opsiyonlar.YolcuGosterme"
                        hide-details=""></v-checkbox>
                      <v-checkbox label="Ödeme Vadesi Basılmasın" v-model="faturaList.Opsiyonlar.OdemeVade"
                        hide-details=""></v-checkbox>
                      <v-checkbox label="İskonto Basılmasın" hide-details=""></v-checkbox>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="opsiyoniptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="faturalasor()">Faturala</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-container fluid="">
            <v-card flat>
              <v-layout row wrap="">


                <v-flex xs12 sm6 md2>
                  <tarihcomp :etiket="'Başlangıç Tarihi'" v-model="faturaList.Filtreler.BaslangicTarih"
                    v-bind:defaultvalue="'ok'" v-bind:value="faturaList.Filtreler.BaslangicTarih"></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp :etiket="'Bitiş Tarihi'" v-bind:defaultvalue="'ok'" v-bind:value="faturaList.Filtreler.BitisTarih"
                    v-model="faturaList.Filtreler.BitisTarih"></tarihcomp>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <v-autocomplete clearable="" @blur="cariat(faturaList.Filtreler.BaslangicCariKod)" label="Başlangıç Cari Seçiniz"
                    append-icon="search" :loading="loading" :items="statecari" item-text="text" cache-items="" id="bascari"
                    item-value="id" v-model="faturaList.Filtreler.BaslangicCariKod" :search-input.sync="searchcari"></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <v-autocomplete clearable="" label="Bitiş Cari Seçiniz" append-icon="search" :loading="loading2"
                    :items="statecari2" item-text="text" cache-items="" item-value="id" v-model="faturaList.Filtreler.BitisCariKod"
                    :search-input.sync="searchcari2"></v-autocomplete>
                </v-flex>

                <v-flex>
                  <v-layout align-center="" justify-start="" fill-height>

                    <!-- <v-btn v-if="devam1btn" color="info" @click="filtrele()" dark>
                      Kayıt Ara
                    </v-btn> -->


                    <div v-if="load1">
                      <v-btn color="info" @click="filtrele()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                    <div v-if="load1">

                      <!-- <v-badge color="green" right overlap>
                        <v-icon v-if="filtreok" slot="badge" dark small>done</v-icon>
                      <v-icon @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="grey lighten-1" large>
                        filter_list
                      </v-icon> -->
                      <!-- <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                          color="info" fab>
                          <v-icon dark>filter_list</v-icon>
                        </v-btn>
                      </v-badge>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>  -->
                    </div>
                  </v-layout>
                </v-flex>



                <v-flex v-if="kayitvarmi" xs12 sm12 md12>
                  <v-card>
                    <v-card-title>
                      <v-alert :value="true" color="error" icon="warning" outline>
                        <span class="font-weight-bold body-1"> {{kayitvarmesaj}} </span>
                      </v-alert>




                      <v-spacer></v-spacer>
                      <v-btn large="" :disabled="seciliBiletbtn" color="info" @click="opsiyonlarial()" dark>
                        Devam Et <v-icon>chevron_right</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-data-table v-if="carilerayni" v-model="selected" :headers="headers" :items="itemsTicket"
                      select-all item-key="BiletNo" :search="search3">
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th>
                            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary
                              hide-details @click.native="toggleAll"></v-checkbox>
                          </th>
                          <th v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                          <td>
                            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                          </td>
                          <td class="text-xs-center">{{ props.item.HavaYoluKodu }}</td>
                          <td class="text-xs-center">{{ props.item.FormNo }}</td>
                          <td class="text-xs-center">{{ props.item.BiletNo }}</td>
                          <td class="text-xs-right">{{ props.item.KdvTutar | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.NetTutar | moneyformat }}</td>
                        </tr>
                      </template>
                    </v-data-table>

                  </v-card>
                </v-flex>

                <v-flex v-if="faturaSonView" xs12 sm12 md12>
                  <v-card>
                    <v-data-table :headers="headers2" :rows-per-page-items=[20,50] :items="faturaItems" :search="search3">
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td v-if="props.item.FaturaStatus==true" class="text-xs-left">
                            <h3 style="color:green;">Başarılı</h3>
                          </td>
                          <td v-if="props.item.FaturaStatus==false" class="text-xs-left">
                            <h3 style="color:red;">Başarısız</h3>
                          </td>
                          <td class="text-xs-left">{{ props.item.FaturaResponse }}</td>
                          <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                          <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                          <td class="text-xs-left">{{ props.item.FaturaGuid }}</td>
                          <td class="text-xs-left">{{ props.item.BiletInfo.FormNo }}</td>
                          <td class="text-xs-left">{{ props.item.BiletInfo.BiletNo }}</td>

                          <v-btn v-if="props.item.FaturaStatus==true" icon class="mx-0">
                            <v-icon color="red" @click="faturayazdir(props.item)">print</v-icon>
                          </v-btn>
                          <v-btn v-if="props.item.FaturaStatus==true" icon class="mx-0">
                            <v-icon color="info" @click="efaturagoster(props.item)">search</v-icon>
                          </v-btn>



                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihcomp'
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"





  export default {
    data() {

      return {
        dovizlifaturami: false,
        kurdegeri: 0,
        kur: null,
        doviztipi: [],
        gdsitems: [],
        itemsairlinelist: [],
        kayitvarmesaj: null,
        kayitvarmi: false,
        devam1btn: true,
        devam2btn: false,
        dialogopsiyon: false,
        text1: '',
        carilerayni: false,
        selected: [],
        seciliBiletbtn: true,
        gibSeri1: [],
        itemsTicket: [],
        faturaItems: [],
        faturaSonView: false,
        hesapgurubu: [],
        dialogmesaj: 'Seçiminiz doğrultusunda biletlerinizi faturalandırmak istediğinize emin misiniz?',
        faturadialog: false,
        faturaList: {
          SirketKodu: null,
          FaturaTarih: null,
          FaturaSeri: null,
          GibSeri: null,
          FaturaNo: null,
          Filtreler: {
            BaslangicCariKod: null,
            BitisCariKod: null,
            BaslangicTarih: null,
            BitisTarih: null,
            HatBilgi: false,
            EFaturaKayitli: false,
            Masraf: null,
            SiparisNo: null,
            HavayoluKodu: null,
            HesapGrubu: null,
            TarihTipi: '0', // 0 : Satış Tarihi, 1 : Satış/Uçuş Tarihi, 2 : Satış/Donuş Tarihi , 3 : Satış/Gidiş - Donuş Tarihi
            Referans: null,
            BolumKodu: null,
            Havayollari: [],
            Odemeler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
            GDSler: [], // K : Kredili, P : Peşin , R: R- Kredi Katlı, F : F-KrediKartlı, C: C-KrediKartlı
            UcusTip: '0', // 0: Hepsi, 1 : Kıbrıs vb Hariç, 2 : Sadece Kıbrıs vb.
            SifirTutar: false,
            CariTip: '0' // 0 : Hepsi, 1 : Bireysel, 2 : Kurumsal

          },
          DovizBilgi: {
            EDovizTipi: null,
            EKur: 0,
            DDovizTipi: null,
            DKur: 0,
          },
          Opsiyonlar: {
            YolcuGosterme: false,
            OdemeVade: false,
            UnvanAdres: false,
            DovizliFatura: false,
            FaturaDetayBas: false,
            SifirTutarBilet: false
          },

          FaturaBilgi: {
            FaturaTip: null,
            FaturaID: null,
            FaturaPdfID: null,
            FaturaXSLTID: null,
            FaturaDipAciklama: null,
          },
          //public EArsivBilgileri EArsivBilgi { get; set; }
          //public FaturaDovizKur DovizBilgi { get; set; }
          //BiletBilgi: ,
          //public EfaturaBilgileri EFaturaBilgi { get; set; }
        },

        search: '',
        filtreok: false,
        odemesekli: [{
          text: 'K-Kredili',
          value: 'K'
        }, {
          text: 'P-Peşin',
          value: 'P'
        }, {
          text: 'R-Kartlı',
          value: 'R'
        }, {
          text: 'C-Kartlı',
          value: 'C'
        }, {
          text: 'F-Kredi Kartlı',
          value: 'F'
        }],

        headers: [{
            text: 'Havayolu Kodu',
            value: 'HavaYoluKodu',
            align: 'center'
          },
          {
            text: 'Form No',
            value: 'FormNo'
          },
          {
            text: 'Bilet No',
            value: 'BiletNo'
          },
          {
            text: 'Kdv Tutar',
            value: 'KdvTutar'
          },
          {
            text: 'Net Tutar',
            value: 'NetTutar'
          }
        ],

        headers2: [{
            text: 'Fatura Durumu',
            value: 'FaturaStatus'
          },
          {
            text: 'Fatura Açıklama',
            value: 'FaturaResponse'
          },
          {
            text: 'Seri',
            value: 'FaturaSeri'
          },
          {
            text: 'No',
            value: 'FaturaNo'
          },
          {
            text: 'GUID',
            value: 'FaturaGuid'
          },
          {
            text: 'FormNo',
            value: 'BiletInfo.FormNo'
          },
          {
            text: 'BiletNo',
            value: 'BiletNo'
          }
        ],

        dizayntipi: [{
            text: 'Default',
            value: 'D'
          },
          {
            text: 'Özel',
            value: 'O'
          },
        ],
        faturadialoggoster: false,
        dizaynsec: [],

        dizaynxslt: [{
          text: 'tek değer',
          value: '0'
        }, ],
        xsltitems: [],
        selected: [],


        statecari: [],
        searchcari: '',
        searchcari2: '',
        Carihesap: '',
        Carihesap2: null,
        dateucus1: null,
        dateucus2: null,



        loading: false,
        loading2: false,
        yedekClass: null,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        statecari2: [],
        dialogfiltre: false,
        hesapkodu: [],
        masrafmerkezi: [],

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      bolumcomp,
      referansmerkezicomp,
      dovizinput,
      reportbrosablon

    },

    mounted() {
      // this.el = this.$refs.fab.$el
    },
    watch: {

      searchcari(val) {
        val && this.carigetir(val)
      },
      searchcari2(val2) {
        val2 && this.carigetir2(val2)
      },
      selected(val3) {
        if (val3.length > 0) {
          this.seciliBiletbtn = false;
        } else {
          this.seciliBiletbtn = true;
        }
      },
      'faturaList.Filtreler.HatBilgi': function () {
        this.dizayngetir();
      },

      'faturaList.Opsiyonlar.DovizliFatura': function (val) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        if (val == true) {
          this.dovizlifaturami = true


          var params1 = {
            CompanyCode: credentials.SirketKodu
          }

          this.$http.post(auth.API_URL + 'api/currency/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.doviztipi = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Döviz'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Döviz'
              this.snackbar = true
            }
          })
        } else {
          this.dovizlifaturami = false;
          this.faturaList.DovizBilgi.DDovizTipi = null;
          this.faturaList.DovizBilgi.DKur = 0;
        }


        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: 'O',
          HatTipi: this.faturaList.Filtreler.HatBilgi,
          TumFiltre: true,
          DovizliFatura: val
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })


      },
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
      faturayazdir(faturainfo) {
        console.log(faturainfo)
        this.faturaList.FaturaBilgi.FaturaPdfID = faturainfo.PdfID
        var prm = {
          id: faturainfo.EFaturaID,
          guid: faturainfo.FaturaGuid
        };

        this.$refs.reportbrosablon.Print(prm).then(
          confirm => {
            // this.status.loading = false;
          },
          confirm => {
            //  this.status.loading = false;
          }
        );
      },
      xsltsec(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {
            this.faturaList.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId
            this.faturaList.FaturaBilgi.FaturaPdfID = element.FaturaPdfID
          }
        });
      },
      cariat(a) {
        var kayit = {
          text: document.getElementById("bascari").value,
          id: a
        }
        this.statecari2 = [];
        this.statecari2.push(kayit);
        this.faturaList.Filtreler.BitisCariKod = a
      },

      kurgetir(kod) {
        var params1 = {
          Tarih: getDateNow(),
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.faturaList.DovizBilgi.DKur = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      mesajiptal() {
        this.faturadialog = false;
      },
      opsiyoniptal() {
        this.dialogopsiyon = false;
      },
      faturalasor() {

        if (this.faturaList.GibSeri != null) {
          this.faturadialog = true;
          this.dialogmesajı = "Seçiminiz doğrultusunda biletlerinizi faturalandırmak istediğinize emin misiniz?'"
        } else {
          this.text1 = 'Lütfen GİB Serisini Seçiniz'
          this.snackbar = true
        }


      },
      toggleAll() {
        if (this.selected.length) this.selected = []
        else this.selected = this.itemsTicket.slice()
      },
      dizayngetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: 'O',
          HatTipi: this.faturaList.Filtreler.HatBilgi,
          TumFiltre: true,
          DovizliFatura: false
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      },
      getList: getList,
      carigetir: carigetir,
      carigetir2: carigetir2,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      faturala: faturala,
      efaturagoster: efaturagoster,
      opsiyonlarial: opsiyonlarial
    }
  }

  function opsiyonlarial() {

    this.faturaList.FaturaTarih = getDateNow();

    this.dizayngetir();
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.faturaList.Filtreler.EFaturaKayitli == false) {

      var params1 = {
        CompanyCode: credentials.SirketKodu
      }
      this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.gibSeri1 = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })


    } else {

      var params1 = {
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.gibSeri1 = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
    this.dialogopsiyon = true


  }

  function filtrele() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetCrsList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      var i = 0;
      response.body.forEach(element => {
        var yeni = {
          text: element,
          value: i
        }
        this.gdsitems.push(yeni)
        i = i + 1;
      });



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })


    if (this.faturaList.Filtreler.EFaturaKayitli == true) {

      var params1 = {
        CompanyCode: credentials.SirketKodu
      }
      this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.gibSeri = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }



    this.dialogfiltre = true
    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.xsltitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })
  }

  function filtrekayit() {
    this.filtreok = true
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtreok = false,
      this.dialogfiltre = false
    this.faturaList.FaturaTarih = getDateNow();
    this.faturaList.Filtreler.HatBilgi = false;
    this.faturaList.Filtreler.EFaturaKayitli = false;
    this.faturaList.Filtreler.Masraf = null;
    this.faturaList.Filtreler.SiparisNo = null;
    this.faturaList.Filtreler.HavayoluKodu = null;
    this.faturaList.Filtreler.HesapGurubu = null;
    this.faturaList.Filtreler.UcusTip = '0';
    this.faturaList.Filtreler.CrsTip = '0';
    this.faturaList.Opsiyonlar.YolcuGosterme = false;
    this.faturaList.Opsiyonlar.OdemeVade = false;
    this.faturaList.Opsiyonlar.UnvanAdres = false;
    this.faturaList.Opsiyonlar.DovizliFatura = false;
    this.faturaList.FaturaBilgi.FaturaTip = null;
    this.faturaList.FaturaBilgi.FaturaID = null;
    this.faturaList.FaturaBilgi.FaturaXSLTID = null;
    this.faturaList.FaturaBilgi.FaturaTip = null;

  }

  function getList() {
    this.kayitvarmi = false;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.dialogfiltre = false
    this.yedekClass = this.faturaList;
    this.faturadialog = false;
    this.itemsTicket = [];
    this.faturaItems = [];
    this.faturaSonView = false;
    this.selected = [];
    this.faturaList.SirketKodu = credentials.SirketKodu
    this.faturaList.FaturaTarih = null;
    var params = this.faturaList
    this.load1 = false
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceSerialTicketList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.length > 0) {
        this.itemsTicket = response.body

        if (this.faturaList.Filtreler.BaslangicCariKod != null && this.faturaList.Filtreler.BitisCariKod != null &&
          this.faturaList.Filtreler.BaslangicCariKod == this.faturaList.Filtreler.BitisCariKod) {
          this.carilerayni = true
          this.load1 = true
          this.kayitvarmi = true;
          this.kayitvarmesaj = "Faturalandırma işlemi henüz tamamlanmadı. " + response.body.length +
            " adet kayıt bulundu. Lütfen faturalandırılacak biletlerinizi seçiniz...";
        } else {

          this.carilerayni = false
          this.selected = response.body
          this.load1 = true
          this.kayitvarmi = true;
          this.kayitvarmesaj = "Faturalandırma işlemi henüz tamamlanmadı. " + response.body.length +
            " adet kayıt bulundu. Faturalandırma işlemine devam etmek için Devam Et seçeneğine tıklayınız...";

          // this.faturala();
        }
      } else {
        this.kayitvarmi = false;
        this.kayitvarmesaj = "";
        this.text1 = 'Faturalanacak Kayıt Bulanamadı'
        this.dialogfiltre = false
        this.snackbar = true
        this.load1 = true
      }

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-InvoiceSerialTicketList'
        this.snackbar = true
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceSerialTicketList'
        this.snackbar = true;
        this.load1 = true;
      }
    })
  }


  function faturala() {

    this.dialogopsiyon = false;
    this.faturadialog = false;
    this.carilerayni = false;
    this.load1 = false;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      ticketList: this.selected,
      invoiceInput: this.yedekClass
    }

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceSerialSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.length > 0) {

        this.faturaSonView = true;
        this.kayitvarmesaj = 'İşlem tamamlandı.';
        this.faturaItems = response.body;
        this.load1 = true;

      } else {
        this.kayitvarmesaj = 'Hiçbir kayıt faturalanmadı.';
        this.faturaSonView = false;
        this.load1 = true;
      }

    }, (response) => {
      if (response.status === 0) {
        this.kayitvarmesaj = 'Hata Oluştu';

        this.text1 = 'Service Unavailable-InvoiceSerialSave'
        this.snackbar = true;
        this.load1 = true;
      } else {
        this.kayitvarmesaj = 'Hata Oluştu';

        this.text1 = 'Service Unavailable-InvoiceSerialSave'
        this.snackbar = true;
        this.load1 = true;
      }
    })
  }

  function efaturagoster(v) {

    var params = {
      id: v.EFaturaID,
      guid: v.FaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialoggoster = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Fatura Show'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Fatura Show'
        this.snackbar = true
      }
    })
  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function carigetir2(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function beforeMount() {


  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>

<style>

</style>